export const INITIAL_VALUE_SIGNATURE = {
  textSignature: true,
};

export const INITIAL_VALUE_ADDITIONAL = {
  additionalFields: '',
};
